import { ApiRoutes } from '../constant/api';
import { api } from '../helpers/axios';
import { IRenter, TRenterRequestType, TRentersResponseType } from '../types/renter.types';

const sortActiveRenters = (renters: IRenter[] | null | undefined) =>
	(renters ?? [])
		.filter((renter) => !renter.is_deleted)
		.sort((a, b) => a.renter_name.localeCompare(b.renter_name, 'ru'));

export const renterApi = {
	getRenters: () =>
		api
			.get(ApiRoutes.Renters, {
				params: {
					offset: 0,
					limit: 1000,
				},
			})
			.then((res) => sortActiveRenters((res.data as TRentersResponseType).objects)),
	createRenter: (payload: TRenterRequestType) => api.post(ApiRoutes.Renters, payload),
	updateRenter: ({ id, payload }: { id: number; payload: TRenterRequestType }) =>
		api.put(`${ApiRoutes.Renters}/${id}`, { id, ...payload }),
	deleteRenter: (id: number) => api.delete(`${ApiRoutes.Renters}/${id}`),
};
